module.exports = require("./ar-EG.js");